import { useState, useEffect } from 'react';
import { Tree, Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { useMainContext } from '../../../hooks/useMainContext';
import {
    TbLayoutSidebarLeftExpand,
    TbLayoutSidebarRightExpand,
} from 'react-icons/tb';

const convertToTreeData = (closets) => {
    return closets.map((closet, index) => ({
        title: `Closet ${index + 1}: ${closet.text || 'Unknown'}`,
        key: `closet-${index}`,
        uuid: closet.uuid,
        children: [
            {
                title: `Bounding Box: [${closet.bbox.join(', ')}]`,
                key: `closet-${index}-bbox`,
            },
            {
                title: `UUID: ${closet.uuid}`,
                key: `closet-${index}-uuid`,
            },
        ],
    }));
};

export const PossibleClosetList = observer(() => {
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [treeData, setTreeData] = useState([]);
    const { viewManager, closetManager } = useMainContext();
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        if (viewManager.updatePossibleClosets()) {
            setTreeData(
                convertToTreeData(
                    viewManager.selectedPagePossibleClosets || [],
                ),
            );
        } else {
            setTreeData([]);
        }
    }, [viewManager.selectedPagePossibleClosets]);

    const toggleSize = () => {
        setIsExpanded((prev) => !prev);
    };

    return (
        <div
            className={`possible-closet-list absolute top-[36px] right-[24px] min-h-[34px] min-w-[40px] rounded-[8px] bg-white shadow-custom z-50 ${isExpanded ? 'expanded' : 'shrunk'} transition-width duration-300`}
            style={{
                width: isExpanded ? '292px' : '20px',
                display: isExpanded ? '' : 'flex',
                justifyContent: isExpanded ? '' : 'center',
                maxHeight: isExpanded ? '448px' : '20px', // Match icon size in shrunk state (header + content height in expanded state)
            }}>
            <div
                style={{
                    display: 'flex',
                    // justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: isExpanded ? '0' : '0',
                    padding: isExpanded ? '12px 16px' : '0', // Match original padding in expanded state, none in shrunk
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    borderBottom: isExpanded ? '1px solid #E5E5E5' : 'none', //
                    // Match border-bottom in expanded state
                }}>
                <Button
                    type="text"
                    icon={
                        isExpanded ? (
                            <TbLayoutSidebarLeftExpand />
                        ) : (
                            <TbLayoutSidebarRightExpand />
                        )
                    }
                    onClick={toggleSize}
                    style={{
                        fontSize: '20px',
                        padding: 0,
                        margin: 0,
                        color: '#1C1C1E',
                        borderRadius: '8px',
                        width: '40px',
                        height: '40px',
                    }}
                />
                {isExpanded && (
                    <h1 className="font-favorit text-[18px] font-normal leading-[24px] text-[#1C1C1E] ml-2">
                        Possible Closets
                    </h1>
                )}
            </div>
            {isExpanded && (
                <div className="content-container">
                    <div className="py-[16px] px-[8px] max-h-[400px] overflow-y-auto">
                        {treeData.length > 0 ? (
                            <Tree
                                onExpand={setExpandedKeys}
                                expandedKeys={expandedKeys}
                                treeData={treeData}
                                defaultExpandAll={false}
                                className="custom-tree"
                                onSelect={(selectedKeys, info) => {
                                    if (info.node.uuid) {
                                        closetManager.showPossibleClosets(
                                            info.node.uuid,
                                        );
                                    }
                                }}
                            />
                        ) : (
                            <div className="text-center text-gray-500">
                                No possible closets for selected page
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
});

export default PossibleClosetList;
